// extracted by mini-css-extract-plugin
module.exports = {"form":"WorkspaceCreateForm_form__xkmMn"};